import { ArrowRight, MapPin } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { Chip } from '../compass/shared';

// Section 8 — sites, customers, materials and costs. An honest relationship
// composition (inputs → site/customer reporting), not a fabricated data-flow.
export const PulseConnect = ({ sp }) => {
  const items = sp.connectItems || [];
  const inputs = items.filter((i) => i !== 'Site and customer reporting');
  return (
    <section aria-labelledby="pulse-connect-heading" data-testid="pulse-connect" className="bg-mist py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          index="08"
          eyebrow="Connected Operations"
          title="Connect workforce activity to where the work happens"
          description={sp.connectCopy}
          testid="pulse-connect-header"
        />
        <Reveal className="mt-12">
          <div className="flex flex-col items-center gap-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-card sm:p-10 lg:flex-row lg:gap-12">
            <ul className="flex flex-1 flex-wrap justify-center gap-2" aria-label="Information Pulse connects">
              {inputs.map((item) => (
                <li key={item}><Chip>{item}</Chip></li>
              ))}
            </ul>
            <ArrowRight className="h-6 w-6 shrink-0 rotate-90 text-gold-600 lg:rotate-0" aria-hidden="true" />
            <div className="flex items-center gap-3 rounded-xl bg-navy-900 px-6 py-5">
              <MapPin className="h-5 w-5 shrink-0 text-gold-500" aria-hidden="true" />
              <p className="text-sm font-extrabold tracking-tight text-white">
                Site and customer reporting
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
